import {
  all, AllEffect,
  call,
  CallEffect, ForkEffect,
  put,
  PutEffect,
  takeEvery,
} from 'redux-saga/effects';
import { reportError } from 'b2b-apps/shop/common/redux/errors/actionCreators';
import {
  downloadPDFSaga,
  printPDFSaga,
} from 'b2b-apps/shop/common/redux/pdf/saga';
import { parseError } from 'b2b-apps/shop/common/utils/api/error';
import {
  downloadProductPdfFulfilled,
  downloadProductPdfRejected,
  printProductPdfFulfilled,
  printProductPdfRejected,
} from 'b2b-apps/shop/product/redux/productPdf/actionCreators';
import {
  DOWNLOAD_PRODUCT_PDF,
  PRINT_PRODUCT_PDF,
} from 'b2b-apps/shop/product/redux/productPdf/actionTypes';
import {
  DownloadProductPdfAction,
  PrintProductPdfAction,
} from 'b2b-apps/shop/product/redux/productPdf/types';
import {
  PRODUCT_MESSAGES,
  showProductToast,
} from 'b2b-apps/shop/product/utils/product';

function* downloadProductPdfSaga(
  action: DownloadProductPdfAction,
): Generator<CallEffect | PutEffect, void> {
  const { content, sku } = action.payload;

  try {
    yield call(downloadPDFSaga, content, `Product ${sku}`);
    yield put(downloadProductPdfFulfilled());
  } catch (error) {
    showProductToast(PRODUCT_MESSAGES.pdfExportError);

    yield put(reportError(action.type, error, action.payload));
    yield put(downloadProductPdfRejected(parseError(error)));
  }
}

function* printProductPdfSaga(
  action: PrintProductPdfAction,
): Generator<CallEffect | PutEffect, void> {
  const { content, sku } = action.payload;

  try {
    yield call(printPDFSaga, content, `Product ${sku}`);
    yield put(printProductPdfFulfilled());
  } catch (error) {
    showProductToast(PRODUCT_MESSAGES.pdfExportError);

    yield put(reportError(action.type, error, action.payload));
    yield put(printProductPdfRejected(parseError(error)));
  }
}

function* productPdfSaga(): Generator<AllEffect<ForkEffect>, void> {
  yield all([
    takeEvery(DOWNLOAD_PRODUCT_PDF, downloadProductPdfSaga),
    takeEvery(PRINT_PRODUCT_PDF, printProductPdfSaga),
  ]);
}

export { productPdfSaga };
